import React from "react";
import { Box } from "@mui/material";

/**
 * A round colored indicator used throughout the consultation:
 *   - as a score-category bullet next to biomarker / impact / "likely
 *     experiencing" labels
 *   - as a separator between text fragments (e.g. "Lung · Brain ·
 *     Nutritional status") — pass `size={3}` for the smaller variant
 *
 * Kept deliberately small (`width: size, height: size, borderRadius: 50%,
 * flexShrink: 0`) so the same primitive covers every place we previously
 * inlined the same six lines of style.
 */
type Props = {
  /** Background color. Defaults to `currentColor` so the dot inherits text color. */
  color?: string;
  /** Dot diameter in pixels. Defaults to 6 (the score-category bullet). */
  size?: number;
};

const ColoredDot: React.FC<Props> = ({ color = "currentColor", size = 6 }) => (
  <Box
    sx={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: "50%",
      backgroundColor: color,
      flexShrink: 0,
    }}
  />
);

export default ColoredDot;
